function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.727 4c-.532 0-1.054.1-1.432.461-.377.36-.497.872-.497 1.402H6.273a.627.627 0 00-.637.615H5v1.23h14v-1.23h-.636a.627.627 0 00-.637-.615h-2.525c0-.53-.12-1.042-.498-1.402-.377-.36-.9-.461-1.431-.461h-2.546zm0 1.268h2.546c.348 0 .457.079.497.115.04.036.12.137.12.48h-3.78c0-.343.08-.444.12-.48.04-.036.15-.115.497-.115zM6.273 8.322v9.834c0 1.016.857 1.844 1.909 1.844h7.636c1.052 0 1.91-.828 1.91-1.844V8.322H6.272zm2.545 1.844h1.273v7.375H8.818v-7.375zm2.546 0h1.272v7.375h-1.272v-7.375zm2.545 0h1.273v7.375h-1.273v-7.375z",
  fill: "current"
});

function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgBin;